import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, PlayCircleIcon, TrophyIcon, BuildingIcon, CalculatorIcon, CoinsIcon, UsersIcon, CalendarIcon, CameraIcon, MessageSquareIcon, DoorOpenIcon, SettingsIcon, HelpCircleIcon } from 'lucide-react';
const mainNav = [{
  name: 'Dashboard',
  path: '/',
  icon: HomeIcon
}, {
  name: 'Sales Library',
  path: '/sales-library',
  icon: PlayCircleIcon
}, {
  name: 'Hall of Fame',
  path: '/hall-of-fame',
  icon: TrophyIcon
}, {
  name: 'Lender Partners',
  path: '/lender-partners',
  icon: BuildingIcon
}, {
  name: 'Mortgage Tools',
  path: '/mortgage-tools',
  icon: CalculatorIcon
}, {
  name: 'Swift Coins',
  path: '/swift-coins',
  icon: CoinsIcon
}, {
  name: 'Company Directory',
  path: '/directory',
  icon: UsersIcon
}, {
  name: 'Swift Holidays',
  path: '/holidays',
  icon: CalendarIcon
}, {
  name: 'Event Photos',
  path: '/event-photos',
  icon: CameraIcon
}, {
  name: 'CEO Updates',
  path: '/ceo-updates',
  icon: MessageSquareIcon
}, {
  name: 'Meeting Rooms',
  path: '/meeting-rooms',
  icon: DoorOpenIcon
}];
const bottomNav = [{
  name: 'Settings',
  path: '/settings',
  icon: SettingsIcon
}, {
  name: 'Help & Support',
  path: '/help',
  icon: HelpCircleIcon
}];
export function Sidebar() {
  const location = useLocation();
  return <div style={{
    width: 260,
    height: '100vh',
    background: '#0A1628',
    color: '#A0AECB',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    left: 0,
    top: 0,
    borderRight: '1px solid rgba(255,255,255,0.05)',
    zIndex: 50
  }} data-id="element-31">
      {/* Logo Area */}
      <div style={{
      height: 72,
      display: 'flex',
      alignItems: 'center',
      padding: '0 24px',
      borderBottom: '1px solid rgba(255,255,255,0.05)',
      marginBottom: 16
    }} data-id="element-32">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12
      }} data-id="element-33">
          <div style={{
          width: 32,
          height: 32,
          background: 'linear-gradient(135deg, #2B8DC4, #1E6FA0)',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'skewX(-8deg)'
        }} data-id="element-34">
            <span style={{
            color: 'white',
            fontWeight: 900,
            fontSize: 18,
            fontStyle: 'italic',
            transform: 'skewX(8deg)'
          }} data-id="element-35">
              S
            </span>
          </div>
          <span style={{
          color: 'white',
          fontSize: 18,
          fontWeight: 900,
          letterSpacing: '-0.02em',
          fontStyle: 'italic'
        }} data-id="element-36">
            Swift Home Loans
          </span>
        </div>
      </div>

      {/* Main Navigation */}
      <div style={{
      flex: 1,
      overflowY: 'auto',
      padding: '0 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }} data-id="element-37">
        <div style={{
        fontSize: 11,
        fontWeight: 800,
        color: 'rgba(255,255,255,0.3)',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        padding: '12px 12px 8px'
      }} data-id="element-38">
          Menu
        </div>
        {mainNav.map(item => {
        const isActive = location.pathname === item.path;
        const Icon = item.icon;
        return <Link key={item.name} to={item.path} style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 12px',
          borderRadius: 8,
          color: isActive ? 'white' : '#A0AECB',
          background: isActive ? 'rgba(43,141,196,0.15)' : 'transparent',
          textDecoration: 'none',
          fontSize: 14,
          fontWeight: isActive ? 700 : 500,
          transition: 'all 0.15s',
          borderLeft: `3px solid ${isActive ? '#2B8DC4' : 'transparent'}`
        }} onMouseEnter={e => {
          if (!isActive) {
            e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
            e.currentTarget.style.color = 'white';
          }
        }} onMouseLeave={e => {
          if (!isActive) {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = '#A0AECB';
          }
        }} data-id="element-39">
              <Icon size={18} color={isActive ? '#2B8DC4' : 'currentColor'} data-id="element-40" />
              {item.name}
            </Link>;
      })}
      </div>

      {/* Bottom Navigation */}
      <div style={{
      padding: '16px',
      borderTop: '1px solid rgba(255,255,255,0.05)',
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }} data-id="element-41">
        {bottomNav.map(item => {
        const Icon = item.icon;
        return <Link key={item.name} to={item.path} style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 12px',
          borderRadius: 8,
          color: '#A0AECB',
          textDecoration: 'none',
          fontSize: 13,
          fontWeight: 500,
          transition: 'all 0.15s'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
          e.currentTarget.style.color = 'white';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = '#A0AECB';
        }} data-id="element-42">
              <Icon size={16} data-id="element-43" />
              {item.name}
            </Link>;
      })}
      </div>
    </div>;
}